import { UserFollowHandler } from "./user-follow-handler";
import { userFollowForm } from "./user-follow-form";

export class UserFollowSetup {
    public static init(): void {
        const containers = userFollowForm.getContainers(document);

        containers.forEach((container) => {
            if (container.dataset.userFollowInitialized === "1") {
                return;
            }

            const handler = new UserFollowHandler(container);
            handler.init();
            container.dataset.userFollowInitialized = "1";
        });
    }
}
